import React, { useContext } from 'react';
import { Navigate, Route, Routes } from 'react-router-dom';
import PropTypes from 'prop-types';
import { Context as StoreContext } from '../../../providers/StoreContextProvider';
import StoreAdminListView from './StoreAdminListView';

const StoreAdminViews = ({ ecomStore, loading }) => {
  const {} = useContext(StoreContext);

  return (
    <Routes>
      <Route
        element={<StoreAdminListView ecomStore={ecomStore} loading={loading} />}
        path="/"
      />
      <Route element={<Navigate replace to="/merchant/admins" />} path="*" />
    </Routes>
  );
};

StoreAdminViews.propTypes = {
  ecomStore: PropTypes.object,
  loading: PropTypes.bool
};

export default StoreAdminViews;
